import { useState } from "react";
import { Container, Typography, Grid, TextField, Button, Card, CardContent, Box, CircularProgress } from "@mui/material";
import { db } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";


const ContactUs = () => {
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    try {
      // Ensure Firestore is properly referenced
      const docRef = await addDoc(collection(db, "contactMessages"), formData);
      console.log("Document written with ID: ", docRef.id);
      setSuccess(true);
      setFormData({ name: "", email: "", mobile: "", message: "" }); // Reset form
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("Failed to send message. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {/* Heading */}
      <Typography variant="h4" align="center" sx={{ fontWeight: "bold", mb: 4 }}>
        Get In <span style={{ color: "#3f51b5" }}>Touch.</span>
      </Typography>

      <Grid container spacing={4} alignItems="stretch">
        {/* Contact Form Section */}
        <Grid item xs={12} md={6} sx={{ display: "flex", flexDirection: "column" }}>
          <Card sx={{ p: 4, boxShadow: 4, borderRadius: 2, flex: 1 }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                Contact Form
              </Typography>

              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth label="Full Name" name="name" variant="outlined" sx={{ mb: 2 }}
                  value={formData.name} onChange={handleChange} required
                />
                <TextField
                  fullWidth label="Email" name="email" variant="outlined" sx={{ mb: 2 }}
                  value={formData.email} onChange={handleChange} required
                />
                <TextField
                  fullWidth label="Mobile Number" name="mobile" variant="outlined" sx={{ mb: 2 }}
                  value={formData.mobile} onChange={handleChange} required
                />
                <TextField
                  fullWidth label="Message" name="message" variant="outlined" multiline rows={7} sx={{ mb: 5 }}
                  value={formData.message} onChange={handleChange} required
                />

                <Button type="submit" variant="contained" color="primary" fullWidth sx={{ py: 1.5, fontSize: "1rem" }} disabled={loading}>
                  {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Submit"}
                </Button>

                {success && (
                  <Typography variant="body2" color="success.main" sx={{ mt: 2 }}>
                    🎉 Message sent successfully!
                  </Typography>
                )}
              </form>
            </CardContent>
          </Card>
        </Grid>

        {/* Locations */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={3}>
            {/* Vijayawada Location */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                Our Vijayawada Location
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Door No: 40-14-8/2, near Jyothi Convention Hall, Benz Circle, Vijayawada, Andhra Pradesh 520010
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "bold", color: "#3f51b5", mb: 2 }}>
                📞 +91 77806 37278 | ✉ Info@cloudupskill.com
              </Typography>
              <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
                <iframe
                  title="Vijayawada Map"
                  width="100%"
                  height="150"
                  style={{ border: 0, borderRadius: "10px" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.572887545911!2d80.6515079!3d16.497150899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fb0ee621206d%3A0xb9d1ada2b357923e!2siSprout%20Business%20Centre%20Vijayawada%20%7C%20Inspiring%20Co-working%20spaces!5e0!3m2!1sen!2sin!4v1742118111581!5m2!1sen!2sin"
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </Card>
            </Grid>

            {/* Hyderabad Location */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                Our Hyderabad Location
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Financial District, Nanakramguda, Telangana 500032
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "bold", color: "#3f51b5", mb: 2 }}>
                📞 +91 93981 62283 | ✉ Info@cloudupskill.com
              </Typography>
              <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
                <iframe
                  title="Hyderabad Map"
                  width="100%"
                  height="150"
                  style={{ border: 0, borderRadius: "10px" }}
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.957198253312!2d78.33567967421018!3d17.41384160204437!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9565b08225c7%3A0xa7d6b34fb4957a47!2sPrestige%20Sky%20Tech!5e0!3m2!1sen!2sin!4v1742119459228!5m2!1sen!2sin"
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ContactUs;
